module.exports = __webpack_public_path__ + "img/logo-cna.fd3beea7.png";